import {useLocation} from 'react-router-dom';
import {Routes} from 'constants/routes';
import {useTranslation} from 'react-i18next';
import {Permission, usePermissions} from 'utils/hooks/permissions/usePermissions';
import {compact} from 'lodash';

export enum LessonsDatabaseTabs {
    NPV_ANALITICS = 'npv-analitics',
    INCIDENTS = 'incidents',
    RISKS_MAP = 'risks-map',
}

export const useTabsLessonsDatabase = () => {
    const location = useLocation();
    const {t} = useTranslation(['npvAnalytics', 'common']);
    const {roles} = usePermissions();
    const canViewRisksMap = roles?.includes(Permission.CAN_VIEW_RISK_MAP);

    const tabs = compact([
        {
            key: LessonsDatabaseTabs.NPV_ANALITICS,
            label: t('nvpAnalyticsTitle'),
            url: `${Routes.LessonsDatabase}/${LessonsDatabaseTabs.NPV_ANALITICS}`,
            search: location.search,
        },
        {
            key: LessonsDatabaseTabs.INCIDENTS,
            label: t('incidents'),
            url: `${Routes.LessonsDatabase}/${LessonsDatabaseTabs.INCIDENTS}`,
            search: location.search,
        },
        canViewRisksMap && {
            key: LessonsDatabaseTabs.RISKS_MAP,
            label: t('risksMap.risksMapTitle'),
            url: `${Routes.LessonsDatabase}/${LessonsDatabaseTabs.RISKS_MAP}`,
            search: location.search,
        },
    ]);

    return {tabs, currentValue: location.pathname.split('?')[0]};
};
